import { render, staticRenderFns } from "./tabGeneral.vue?vue&type=template&id=2c14bde3&"
import script from "./tabGeneral.vue?vue&type=script&lang=js&"
export * from "./tabGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports